import React, {useState} from 'react'
import {Form, Input, Button} from 'antd'
import { makeStyles } from '@material-ui/core'
import {PhoneOutlined, LockOutlined} from '@ant-design/icons'
import {trackPromise, usePromiseTracker} from 'react-promise-tracker'
import { useRouter } from '../../routes'
import { useData } from '../../data'

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
        width: '100%'
    },
    content: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        minWidth: '20%'
    },
    error: {
        fontWeight: 'bold',
        fontSize: 16,
        color: 'red'
    },
    login: {
        textAlign: 'center'
    },
    logo: {
        display: 'flex',
        margin: theme.spacing(3, 0),
        justifyContent: 'center',
        alignItems: 'center'
    },
    image: {
        width: '8rem',
        height: '8rem'
    },
    logoImage: {
        height: 100,
        marginBottom: theme.spacing(3)
    }
}))

/**
 * Two AF page component
 * 
 * Provides user with 2FA code field and connect
 * to server to verify the details.
 * 
 * If authentication fails, it renders an error text
 */

const TwoFAPage = (props) => {
    const [error, setError] = useState(null)

    const classes = useStyles()
    const data = useData()
    const auth = data.auth()

    const router = useRouter()

    // login callback
    const twofa = ({code}) => {
        setError(null)

        trackPromise(
            auth.twofa(code)
                .then((user) => {
                    // route to dashboard
                    router.push('/dashboard')
                }).catch(error => {
                    console.log(error)
                    
                    setError("An error occured. Please try again")
                })
        )
    }

    const {promiseInProgress} = usePromiseTracker()

    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <img src="/apple-touch-icon.png" alt="logo" className={classes.logoImage} />
                <p>Please input 2FA Code received at your email</p>
                <Form
                    layout="vertical"
                    onFinish={twofa}
                    name="login-form"
                >
                    <Form.Item name="code" rules={[{required: true}]}>
                        <Input placeholder="Two FA COde" size="large" />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" block size="large" loading={promiseInProgress} htmlType="submit" >Verify</Button>
                    </Form.Item>

                    <Form.Item>
                        <p className={classes.error}>{error}</p>
                    </Form.Item>

                </Form>
            </div>
        </div>
    )
}

export default TwoFAPage